GP.views.FriendsListItem = Backbone.Marionette.ItemView.extend({
    template: function(serialized_data) {
        return template('friend-user', serialized_data);
    },
    className: 'friend-user-item media-item',
    events: {
        'click .approve-request': 'approve_request',
        'click .deny-request':    'deny_request',
        'click a.undo':           'undo_request',
        'click .mass-action':     'handle_checkbox',
        'click .user-thumb':      'handle_click',
        'click .checkbox-wrap':   'handle_label_click',
        'click .info-wrap':       'open_thread'
    },
    templateHelpers: {
        user_online: function() {
            return (this.friend && this.friend.online) ? '' : 'hide';
        },
        user_online_class: function() {
            return (this.friend && this.friend.online) ? 'friend-user-online' : '';
        },
        is_verified: function() {
            return (this.friend.verified_pic === 'Y');
        }
    },
    initialize: function(opts) {
        // re-render itemview on model change
        this.listenTo(this.model, 'change', this.render);
        this.event_ns = opts.event_ns;
    },
    handle_click: function(evnt) {
        GP.vent.trigger('Page:redirect', this.model.url());
        GP.vent.trigger('RightDrawer:close_if_mobile');
    },
    open_thread: function(evnt) {
        evnt.stopPropagation();
        var user_model = this.model;

        // don't open thread if blocked users are clicked
        if (this.model.get('friendship') == 'blocked') {
            return false;
        }

        // returns a promise, so add the done/fail callbacks here
        var done = function(thread_json) {
            if (thread_json && thread_json.threads && thread_json.threads.length) {
                // adding a couple of special case flags
                thread_json.show_pane = false;
                // thread_json.threads[0].thread_style = 'docked';

                if (MoshPit.get_size() == 'mobile') {
                    localStorage.setItem('right_drawer_scrolltop', window.scrollY);
                    thread_json.opened_from = 'friends';
                }
                GP.vent.trigger('MessagePane:send_message', user_model.get('duid'), thread_json);
            }
        };
        var fail = function() {
            // fail error/action here
        };
        this.model.thread_json(done, fail);
    },
    handle_label_click: function(evnt) {
        // make sure we don't bubble the click event up and fire the handler for .info-wrap parent
        evnt.stopPropagation();
    },
    handle_checkbox: function(evnt) {
        // make sure we don't bubble the click event up and fire the handler for .info-wrap parent
        evnt.stopPropagation();
        if ($('#friend-pane input.mass-action:checked').length) {
            MoshPit.add_state('friend-pane-mass-action');
        } else {
            MoshPit.remove_state('friend-pane-mass-action');
        }
    },
    approve_request: function(evnt) {
        // disable button then trigger the approve function in the FriendPane module
        $(evnt.currentTarget).prop('disabled', true);
        GP.vent.trigger(this.event_ns + ":approve", this.model);
    },
    deny_request: function(evnt) {
        GP.vent.trigger(this.event_ns + ":decline", this.model);
    },
    undo_request: function(evnt) {
        GP.vent.trigger(this.event_ns + ":undo_request", this.model);
    },
    onRender: function() {
        var classname = "friendship-" + this.model.get('friendship');
        if (this.model.get('dim')) {
            classname += ' dim';
        }
        this.$el.removeClass().addClass(this.className + ' ' + classname);
    },
    // return data to pass to handlebar template
    serializeData: function() {
        var tdata = {};
        // show users who's friendship type is other than "remove"
        if (this.model.get('friendship') != 'remove') {
            tdata = {
                friend: this.model.toJSON()
            };
        }
        return tdata;
    }
});


GP.views.FriendsList = Backbone.Marionette.CollectionView.extend({
    childView: GP.views.FriendsListItem,
    getEmptyView: function() {
        var fp_view = GP.reqres.request('FriendPane:get_current_view');
        if (GP.sdata.my_user.unconverted_trial && fp_view == 'viewed') {
            // if no results returned for an unconverted trial user on who's viewed me, use alternate emptyView
            return GP.views.NoResultsTrialUserItemView;
        } else if (GP.sdata.my_user.membership === 'PENDING_FREE' && fp_view == 'viewed') {
            return GP.views.NoResultsPendingUserItemView;
        } else {
            return GP.views.NoResultsItemView;
        }
    }
});
